import { Box, BoxProps, ColorOptions, Loader, ModBox, Spacer, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { isEmpty } from '@jfs/utils'
import { useEffect, useState } from 'react'
import { DropdownOptimised } from '../../components/DropdownNew'
import { DropdownTypes } from '../../components/DropdownNew/types'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import { getSchemaData } from '../../utils/constants'
import { Account } from './Account'

const SourceAccountConfig = () => {
  const [groupId, setGroupId] = useState<any>('')
  const [subGroupId, setSubGroupId] = useState<any>('')

  const {
    fetchSourceAccConfig,
    getSourceAccountConfig,
    addSourceAccountConfig,
    accessConfig,
    fetchGroupIds,
    fetchSubGroupIds,
    getGroupIds,
    getSubGroupIds,
    getAllProcessingEntities,
    fetchCodeNames,
  } = useStores((store) => ({
    fetchSourceAccConfig: store?.sourceAccountConfig?.fetchSourceAccConfig,
    getSourceAccountConfig: store?.sourceAccountConfig?.getSourceAccountConfig,
    addSourceAccountConfig: store?.sourceAccountConfig?.addSourceAccConfig,
    fetchGroupIds: store?.sourceAccountConfig?.fetchGroupIds,
    fetchSubGroupIds: store?.sourceAccountConfig?.fetchSubGroupIds,
    accessConfig: store.user.getAccessConfig(['ess', 'source_account_config']),
    getGroupIds: store.sourceAccountConfig.getGroupids,
    getSubGroupIds: store.sourceAccountConfig.getSubGroupids,
    getAllProcessingEntities: store?.processingEntity?.getAll,
    fetchCodeNames: store?.user?.fetchCodeNames,
  }))

  const [formVisible, setFormVisible] = useState(false)
  const [lazyGetGroupIds] = useLazyApiData(fetchGroupIds)
  const [lazyGetSubGroupIds, { state: subGrpIdApiState }] = useLazyApiData(fetchSubGroupIds)
  const [lazyFetchModeNames, lazyFetchModeNamesHandler] = useLazyApiData(fetchCodeNames)
  const [lazyFetchSubModeNames, lazyFetchSubModeNamesHandler] = useLazyApiData(fetchCodeNames)
  const [lazyFetchEntityType, lazyFetchEntityTypeHandler] = useLazyApiData(fetchCodeNames)
  const [lazyFetchTnxModes, fetchTnxModesHandler] = useLazyApiData(fetchCodeNames)

  const [lazyFetchSourceAccConfig, { state, data: fetchApiData }] = useLazyApiData(fetchSourceAccConfig)
  const [addSourceAccountConfigApi, { state: addApiState }] = useLazyApiData(addSourceAccountConfig)
  const [lazyGetAllProcessingEntities, { state: processingEntityApiState }] = useLazyApiData(getAllProcessingEntities)

  useEffect(() => {
    const isAdd =
      !isEmpty(groupId) &&
      !isEmpty(subGroupId) &&
      fetchApiData?.errorCode === '38212' &&
      fetchApiData?.message === 'Payout source account not found'

    if ((state === 'fulfilled' && processingEntityApiState) || isAdd) {
      setData(
        getSourceAccountConfig(
          getSchemaData(lazyFetchSubModeNamesHandler?.data ?? [], 'SOURCE_ACC_CONFIG'),
          getSchemaData(lazyFetchModeNamesHandler?.data ?? [], 'SOURCE_ACC_CONFIG'),
          getSchemaData(lazyFetchEntityTypeHandler?.data ?? [], 'SOURCE_ACC_CONFIG'),
          getSchemaData(fetchTnxModesHandler?.data ?? [], 'SOURCE_ACC_CONFIG'),
          isAdd,
        ),
      )
      setFormVisible(true)
    }
  }, [state])

  useEffect(() => {
    setFormVisible(false)
  }, [groupId, subGroupId])

  useEffect(() => {
    getGroupIds()?.length === 0 && lazyGetGroupIds()
    lazyGetAllProcessingEntities()
    lazyFetchModeNames('INST_TYPE')
    lazyFetchSubModeNames('TXN_TYPE')
    lazyFetchEntityType('ENTITY_TYPE')
    lazyFetchTnxModes('TXN_MODE')
  }, [])

  useEffect(() => {
    if (addApiState === 'fulfilled') {
      handleSearch()
    }
  }, [addApiState])
  useEffect(() => {
    !isEmpty(groupId) && getSubGroupIds(groupId)?.length === 0 && lazyGetSubGroupIds(groupId)
  }, [groupId])
  const handleSearch = () => {
    lazyFetchSourceAccConfig(groupId, subGroupId)
  }

  const [data, setData] = useState([])

  console.log('data=', data)

  const btnEnabled = !isEmpty(groupId) && !isEmpty(subGroupId)
  const subGroupIds = getSubGroupIds(groupId)
  const handleOnGroupChange = (val) => {
    val !== groupId && setSubGroupId('')
    setGroupId(val)
  }
  return (
    <Box {...styles.container} nativeID="vertical-scroll">
      <Text title={'Source Payout Config'} fontSize={28} fontWeight={'600'} color={'#5a5c69' as ColorOptions} />
      <Box w={240} p={16}>
        <DropdownOptimised
          testID="groupid"
          title={'Group Id'}
          placeHolder={'Group Id'}
          onChange={handleOnGroupChange}
          data={[...getGroupIds()]}
          value={groupId}
          type={DropdownTypes.DEFAULT_WITH_IMAGE}
          hide={false}
          showSearch={true}
        />
        <Spacer direction={'vertical'} size={16} />
        <DropdownOptimised
          testID="subgroupid"
          placeHolder={'Subgroup Id'}
          title={'Subgroup Id'}
          onChange={setSubGroupId}
          data={subGroupIds}
          value={subGroupId}
          type={DropdownTypes.DEFAULT_WITH_IMAGE}
          hide={!groupId || subGroupIds?.length === 0}
          showSearch={true}
        />
        {subGrpIdApiState === 'pending' && <Loader />}
        <Spacer direction={'vertical'} size={16} />
        <ButtonNew
          hide={!isAccessible(accessConfig, 'fetch')}
          title={'Search'}
          onPress={handleSearch}
          disabled={!btnEnabled}
          isLoading={state === 'pending'}
        />
        <ModBox pv={16} show={formVisible}>
          {data?.map((item, index) => {
            return (
              <Account
                key={index}
                data={item}
                index={index}
                isAdd={item.isNew}
                groupId={groupId}
                subGroupId={subGroupId}
                addSourceAccountConfigApi={addSourceAccountConfigApi}
                addApiState={addApiState}
              />
            )
          })}
          <Spacer size={32} />
          <Box
            height={32}
            border={1}
            borderColor={'PRIMARY'}
            align="center"
            justify="center"
            padding={18}
            underlayColor={'GRAY_BORDER'}
            onPress={() => {
              setData(
                getSourceAccountConfig(
                  getSchemaData(lazyFetchSubModeNamesHandler?.data ?? [], 'SOURCE_ACC_CONFIG'),
                  getSchemaData(lazyFetchModeNamesHandler?.data ?? [], 'SOURCE_ACC_CONFIG'),
                  getSchemaData(lazyFetchEntityTypeHandler?.data ?? [], 'SOURCE_ACC_CONFIG'),
                  getSchemaData(fetchTnxModesHandler?.data ?? [], 'SOURCE_ACC_CONFIG'),
                  true,
                ),
              )
            }}>
            <Text color={'PRIMARY'}>Add New</Text>
          </Box>
        </ModBox>
      </Box>
    </Box>
  )
}

const styles = {
  container: {
    h: '100%',
    bg: 'WHITE',
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
    borderRadius: 8,
    p: 20,
    overflow: 'auto',
  } as BoxProps,
}

export default SourceAccountConfig
